import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * component designed to provide events when it comes into or out of the viewport.
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["scrollCheck"];
class ScrollCheckComponent {
    constructor() {
        /**
         * string to apply to the style.bottom of this element, allowing for an offset of where it is visible
         * versus where it was placed in the html.
         *
         * default value '0px'
         */
        this.offset = '0px';
        /**
         * string to load in this element, allowing for visibility of the element for debugging purposes.  Only
         * intended for debugging usage.
         *
         * default value ''
         */
        this.debuggingText = '';
        this.inViewHasChanged = new EventEmitter();
        this.cameIntoView = new EventEmitter();
        this.wentOutOfView = new EventEmitter();
        this._observer = new IntersectionObserver(this._onIntersect.bind(this), {
            rootMargin: '0px',
            threshold: 1.0,
        });
    }
    ngAfterViewInit() {
        this._observer.observe(this._scrollCheckElement.nativeElement);
    }
    _onIntersect(entries, observer) {
        const isOnScreen = entries[0].isIntersecting;
        this.inViewHasChanged.emit(isOnScreen);
        if (isOnScreen) {
            this.cameIntoView.emit();
        }
        else {
            this.wentOutOfView.emit();
        }
    }
}
ScrollCheckComponent.ɵfac = function ScrollCheckComponent_Factory(t) { return new (t || ScrollCheckComponent)(); };
ScrollCheckComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ScrollCheckComponent, selectors: [["scroll-check"]], viewQuery: function ScrollCheckComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._scrollCheckElement = _t.first);
    } }, inputs: { offset: "offset", debuggingText: "debuggingText" }, outputs: { inViewHasChanged: "inViewHasChanged", cameIntoView: "cameIntoView", wentOutOfView: "wentOutOfView" }, decls: 3, vars: 3, consts: [[1, "scrollCheck"], ["scrollCheck", ""]], template: function ScrollCheckComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0, 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("bottom", ctx.offset);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.debuggingText);
    } }, styles: [".scrollCheck[_ngcontent-%COMP%] {\n                position: relative;\n            }"] });
ScrollCheckComponent.ctorParameters = () => [];
ScrollCheckComponent.propDecorators = {
    offset: [{ type: Input }],
    debuggingText: [{ type: Input }],
    inViewHasChanged: [{ type: Output }],
    cameIntoView: [{ type: Output }],
    wentOutOfView: [{ type: Output }],
    _scrollCheckElement: [{ type: ViewChild, args: ['scrollCheck',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ScrollCheckComponent, [{
        type: Component,
        args: [{
                selector: 'scroll-check',
                template: '<span #scrollCheck class="scrollCheck" [style.bottom]="offset">{{ debuggingText }}</span>',
                styles: [`
            .scrollCheck {
                position: relative;
            }
        `]
            }]
    }], function () { return []; }, { offset: [{
            type: Input
        }], debuggingText: [{
            type: Input
        }], inViewHasChanged: [{
            type: Output
        }], cameIntoView: [{
            type: Output
        }], wentOutOfView: [{
            type: Output
        }], _scrollCheckElement: [{
            type: ViewChild,
            args: ['scrollCheck']
        }] }); })();

class VisibilityModule {
}
VisibilityModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: VisibilityModule });
VisibilityModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function VisibilityModule_Factory(t) { return new (t || VisibilityModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VisibilityModule, { declarations: function () { return [ScrollCheckComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ScrollCheckComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VisibilityModule, [{
        type: NgModule,
        args: [{
                declarations: [ScrollCheckComponent],
                exports: [ScrollCheckComponent],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ScrollCheckComponent, VisibilityModule };


//# sourceMappingURL=mt-ng2-visibility-module.js.map